import React from 'react';

import {AppContext} from '../../../AppModule/Context';

import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import MessageCue from '../../common/messageCue/messageCue';

import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './cFooterComponent.css';

const TAB_TEXT_VISIBLE_TIME = 8 * 1000;

class CFooterComponent extends React.Component {
  constructor(props) {
    super(props);
    this.footerRef = React.createRef();
    this.state = {
      foregroundWidgets: [],
      urlAppType: VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE, //will be one of VIDABOO_CONSTANTS.WIDGET_APP_TYPES type
      isFooterTabTextVisible: false,
      hoveredFooterTabText: null,
      showFadeOutTextAnim: false,
      showIconsAnim: false,
      mousePosition: {x: 0, y: 0},
    };
  }

  componentDidMount = () => {
    this.setState(
      {
        foregroundWidgets:
          this.props.mentor.mentorDto.appControlDto.foregroundWidgets,
      },
      () => {
        this.handleUrlAppType();
      },
    );
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.mentor.mentorDto.appControlDto.foregroundWidgets.length !==
        prevProps.mentor.mentorDto.appControlDto.foregroundWidgets.length ||
      this.props.selectedWidgetAppType !== prevProps.selectedWidgetAppType ||
      this.checkIfForeGroundWidgetsChanged(
        this.props.mentor.mentorDto.appControlDto.foregroundWidgets,
        prevProps.mentor.mentorDto.appControlDto.foregroundWidgets,
      )
    ) {
      this.setState({
        foregroundWidgets:
          this.props.mentor.mentorDto.appControlDto.foregroundWidgets,
      });
      this.handleWidgetDisabledCase();
    }
  };

  componentWillUnmount = () => {
    if (this.tabTextTimeout) {
      window.clearTimeout(this.tabTextTimeout);
    }
    if (this.tabTextAnimTimeout) {
      window.clearTimeout(this.tabTextAnimTimeout);
    }
  };

  handleUrlAppType = () => {
    if (this.props.isPersonalPage) {
      // personal page
      const searchUrl = window.location.search;
      if (searchUrl.includes('?')) {
        const urlAppType = new URLSearchParams(searchUrl).get('start');
        if (urlAppType) {
          const selectedWidgetAppType =
            utilsService.getSelectedWidgetAppType(urlAppType);
          if (
            selectedWidgetAppType !== VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE
          ) {
            this.setState(
              {
                urlAppType: selectedWidgetAppType,
              },
              () => {
                this.handleWidgetDisabledCase(true);
              },
            );
          }
        }
      }
    } else {
      // widget
      if (!utilsService.isEmptyHash(this.props.actionClickData)) {
        this.setState(
          {
            urlAppType: utilsService.getSelectedWidgetAppType(
              null,
              this.props.actionClickData,
            ),
          },
          () => {
            this.handleWidgetDisabledCase(true);
          },
        );
      } else {
        const searchUrl = window.location.search;
        if (searchUrl.includes('?')) {
          const urlAppType = new URLSearchParams(searchUrl).get('start');
          if (urlAppType) {
            this.setState(
              {
                urlAppType: utilsService.getSelectedWidgetAppType(urlAppType),
              },
              () => {
                this.handleWidgetDisabledCase(true);
              },
            );
          }
        }
      }
    }
  };

  handleWidgetDisabledCase = (isMounted) => {
    const index =
      this.props.mentor.mentorDto.appControlDto.foregroundWidgets.findIndex(
        (i) => i === this.state.urlAppType,
      );
    if (
      index === -1 &&
      this.state.urlAppType !== VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE
    ) {
      let foregroundWidgets = [
        ...this.props.mentor.mentorDto.appControlDto.foregroundWidgets,
      ];
      foregroundWidgets.push(this.state.urlAppType);
      this.setState({foregroundWidgets}, () => {
        if (isMounted) {
          this.selectFooterOption(this.state.urlAppType);
        }
      });
    }
  };

  checkIfForeGroundWidgetsChanged = (currentArray, prevArray) => {
    const prevArrayLength = prevArray.length;
    let forgeGroundWidgetsOrderChanged = false;
    for (let i = 0; i < prevArrayLength; i++) {
      if (prevArray[i] !== currentArray[i]) {
        forgeGroundWidgetsOrderChanged = true;
        break;
      }
    }
    return forgeGroundWidgetsOrderChanged;
  };

  selectFooterOption = (widgetAppType) => {
    this.props.onFooterOptionSelected(widgetAppType);
    this.setState({
      selectedWidgetAppType: widgetAppType,
    });
  };

  handleMouseEnter = (selectedWidgetAppType) => {
    if (this.tabTextTimeout) {
      window.clearTimeout(this.tabTextTimeout);
    }
    if (this.tabTextAnimTimeout) {
      window.clearTimeout(this.tabTextAnimTimeout);
    }
    this.setState({
      isFooterTabTextVisible: true,
      hoveredFooterTabText: this.getCommunicationTabLanguageSpecificText(
        selectedWidgetAppType,
      ),
      showFadeOutTextAnim: false,
    });
    this.tabTextAnimTimeout = setTimeout(() => {
      this.setState({
        showFadeOutTextAnim: true,
      });
    }, TAB_TEXT_VISIBLE_TIME / 2);
    this.tabTextTimeout = setTimeout(() => {
      this.setState({
        isFooterTabTextVisible: false,
        hoveredFooterTabText: null,
        showFadeOutTextAnim: false,
      });
    }, TAB_TEXT_VISIBLE_TIME);
  };

  handleMouseMove = (e) => {
    if (this.props.disableIconsAnim) return;
    const footerDiv = this.footerRef.current.getBoundingClientRect();
    const mouseXPos = e.clientX - footerDiv.left;
    const mouseYPos = e.clientY - footerDiv.top;
    this.setState({
      showIconsAnim: true,
      mousePosition: {x: mouseXPos, y: mouseYPos},
    });
  };

  handleMouseLeave = () => {
    if (this.props.disableIconsAnim) return;
    this.setState({
      showIconsAnim: false,
      mousePosition: {x: 0, y: 0},
    });
  };

  calculateIconScale = (index) => {
    if (!this.state.showIconsAnim) return 1;
    const footerWidth = this.footerRef.current.offsetWidth;
    const centerX =
      (index + 0.5) * (footerWidth / this.state.foregroundWidgets.length);
    const currentDistance = Math.abs(centerX - this.state.mousePosition.x);
    const maxDistance = 200;
    const scale = Math.max(1, 1.4 - currentDistance / maxDistance);
    return scale;
  };

  getCommunicationTabLanguageSpecificText = (selectedWidgetAppType) => {
    const {mentorDto} = this.props.mentor;
    const editableTexts = mentorDto.appControlDto?.widgetEditableTexts || {};
    const widgetKey = `CHANNEL_${selectedWidgetAppType}`;
    let customText = editableTexts[widgetKey];

    if (customText) return customText;

    switch (selectedWidgetAppType) {
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT:
        return this.context.languageSet.CONSOLTO_WIDGET.CHAT;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL:
        return this.context.languageSet.CONSOLTO_WIDGET.WEBCALL;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP:
        return this.context.languageSet.CONSOLTO_WIDGET.WHATSAPP;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER:
        return this.context.languageSet.CONSOLTO_WIDGET.MESSENGER;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK:
        return this.context.languageSet.CONSOLTO_WIDGET.CUSTOM_LINK;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL:
        return this.context.languageSet.CONSOLTO_WIDGET.PHONE;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR:
        return this.context.languageSet.CONSOLTO_WIDGET.CONTACT;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING:
        return this.context.languageSet.CONSOLTO_WIDGET.SCHEDULE;
      default:
        return '';
    }
  };

  getIconType = (selectedWidgetAppType) => {
    switch (selectedWidgetAppType) {
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT:
        return 'ChatIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL:
        return 'VideoIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP:
        return 'WhatsappIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER:
        return 'MessengerIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK:
        return 'CustomLinkIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL:
        return 'PhoneIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR:
        return 'FormIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING:
        return 'ScheduleIcon';
      default:
        return '';
    }
  };

  render() {
    const {showFadeOutTextAnim, isFooterTabTextVisible, hoveredFooterTabText} =
      this.state;
    const {
      disableIconsAnim,
      isDemo,
      isInAgentList,
      isPersonalPage,
      hideFooterTabText,
      selectedWidgetAppType,
    } = this.props;

    let teamCtaBtnPrimaryBgColor;
    if (isInAgentList) {
      teamCtaBtnPrimaryBgColor = getComputedStyle(
        document.documentElement,
      ).getPropertyValue('--et-team-cta-btn-primary-background-color');
    }
    const hideFooterUI =
      this.state.foregroundWidgets?.length <= 1 &&
      !isInAgentList &&
      !isPersonalPage;

    return (
      <div
        className={`et-widget-footer-container ${isPersonalPage ? 'et-personal-page-footer-container' : ''} ${hideFooterUI ? 'et-wf-widget-empty-footer' : ''}`}>
        {hideFooterUI ? (
          <></>
        ) : (
          <>
            {!hideFooterTabText && !isPersonalPage && (
              <div className="et-owc-footer-selected-tab-txt-wrap">
                {isFooterTabTextVisible && (
                  <div
                    className={`et-owc-footer-selected-tab-txt ${showFadeOutTextAnim ? 'et-owc-footer-text-fade-out-anim' : ''}`}>
                    {hoveredFooterTabText}
                  </div>
                )}
              </div>
            )}
            <div
              ref={this.footerRef}
              className="et-owc-footer "
              style={{
                background: isInAgentList
                  ? `linear-gradient(
            to right,
            ${teamCtaBtnPrimaryBgColor + 10} -10%,
            ${teamCtaBtnPrimaryBgColor} 22%
          )`
                  : 'transparent',
              }}>
              <div
                className="et-owc-footer-btns-wrap"
                onMouseMove={this.handleMouseMove}
                onMouseLeave={this.handleMouseLeave}>
                {this.state.foregroundWidgets &&
                  this.state.foregroundWidgets.map((fgWidget, index) => {
                    const CommunicationTab =
                      CommunicationIcons[this.getIconType(fgWidget)];
                    return (
                      <div key={index} className="et-owc-footer-btn-txt-wrap">
                        <div
                          className="et-owc-footer-btn"
                          style={{
                            transform: disableIconsAnim
                              ? 'scale(1)'
                              : `scale(${this.calculateIconScale(index)})`,
                          }}
                          onClick={() => {
                            this.selectFooterOption(fgWidget);
                          }}
                          onMouseEnter={() => {
                            this.handleMouseEnter(fgWidget);
                          }}>
                          <CommunicationTab
                            showNewUI
                            fillColor={
                              fgWidget === selectedWidgetAppType
                                ? 'var(--et-mentor-cta-btn-primary-background-color-fc)'
                                : 'var(--et-mentor-secondary-text-color)'
                            }
                          />
                          {!isDemo &&
                            !isInAgentList &&
                            fgWidget ===
                              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT && (
                              <MessageCue isWidgetFooter={true} />
                            )}
                        </div>
                        {isPersonalPage && (
                          <div className="et-owc-footer-selected-tab-txt">
                            {this.getCommunicationTabLanguageSpecificText(
                              fgWidget,
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

CFooterComponent.contextType = AppContext;
export default CFooterComponent;
